module.exports = __webpack_public_path__ + "static/highlight-d6915d289e176b0ba7943e38bb35689c.png";